import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Box,
    Button,
    Input,
    Heading,
    Alert,
    AlertIcon,
    FormControl,
    FormLabel,
    useToast
} from '@chakra-ui/react';
import { SupabaseClient } from '../../supabaseClient';
import { useNavigate } from 'react-router-dom';

const LoginPage = () => {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const toast = useToast();
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setErrorMsg(''); // clear any previous error

        // Basic validation
        if (!email.trim() || !password) {
            const msg = t('login.errors.required');
            setErrorMsg(msg);
            toast({
                title: t('login.toast.errorTitle'),
                description: msg,
                status: 'error',
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        setIsLoading(true);
        const { error } = await SupabaseClient.auth.signInWithPassword({
            email,
            password,
        });
        setIsLoading(false);

        if (error) {
            setErrorMsg(error.message);
            toast({
                title: t('login.toast.loginErrorTitle'),
                description: error.message,
                status: 'error',
                duration: 3000,
                isClosable: true,
            });
        } else {
            toast({
                title: t('login.toast.successTitle'),
                description: t('login.toast.successDescription'),
                status: 'success',
                duration: 3000,
                isClosable: true,
            });
            navigate('/');
        }
    };

    return (
        <Box maxW="500px" mx="auto" p={4}>
            <Heading as="h2" size="lg" textAlign="center" mb={4}>
                {t('login.title')}
            </Heading>

            {errorMsg && (
                <Alert status="error" mb={4}>
                    <AlertIcon />
                    {errorMsg}
                </Alert>
            )}

            <form onSubmit={handleLogin}>
                <FormControl id="email" isRequired mb={4}>
                    <FormLabel>{t('login.form.email.label')}</FormLabel>
                    <Input
                        type="email"
                        placeholder={t('login.form.email.placeholder')}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </FormControl>

                <FormControl id="password" isRequired mb={4}>
                    <FormLabel>{t('login.form.password.label')}</FormLabel>
                    <Input
                        type="password"
                        placeholder={t('login.form.password.placeholder')}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </FormControl>

                <Button type="submit" colorScheme="blue" isLoading={isLoading} width="full">
                    {t('login.form.submit')}
                </Button>
            </form>
        </Box>
    );
};

export default LoginPage;
